import { createSlice } from "@reduxjs/toolkit";
import { taasInnerTableKeys, TAAS_TABLE_SECTION_KEYS, PROJECT_BASED_TABLE_KEYS, STAFF_AUGMENTATION_AND_BOT_TABLE_KEYS } from "./TaasTableSectionConfig";


let tableData = {
    [taasInnerTableKeys.SURVEY_SCRIPTING]: 0,
    [taasInnerTableKeys.DATA_PROCESSING]: 0,
    [taasInnerTableKeys.DATA_VISUALIZATION]: 0,
    cost: 0
}

const initialState = {
    [TAAS_TABLE_SECTION_KEYS.TAAS_BASED]: tableData,
    [TAAS_TABLE_SECTION_KEYS.PROJECT_BASED]: {
        [PROJECT_BASED_TABLE_KEYS.ESTIMATED_NUMBER_OF_HOURS_PER_MONTH]: tableData,
        [PROJECT_BASED_TABLE_KEYS.ESTIMATED_NUMBER_OF_PROJECTS_PER_MONTH]: tableData
    },
    [TAAS_TABLE_SECTION_KEYS.STAFF_AUGMENTATION]: {
        [STAFF_AUGMENTATION_AND_BOT_TABLE_KEYS.ESTIMATED_NUMBER_OF_FTEs]: tableData,
        [STAFF_AUGMENTATION_AND_BOT_TABLE_KEYS.SPECIFY_TIME_IN_MONTHS]: tableData
    },
    [TAAS_TABLE_SECTION_KEYS.BOT]: {
        [STAFF_AUGMENTATION_AND_BOT_TABLE_KEYS.ESTIMATED_NUMBER_OF_FTEs]: tableData,
        [STAFF_AUGMENTATION_AND_BOT_TABLE_KEYS.SPECIFY_TIME_IN_MONTHS]: tableData
    },
    activeCards: {
        [TAAS_TABLE_SECTION_KEYS.TAAS_BASED]: false,
        [TAAS_TABLE_SECTION_KEYS.PROJECT_BASED]: false,
        [TAAS_TABLE_SECTION_KEYS.STAFF_AUGMENTATION]: false,
        [TAAS_TABLE_SECTION_KEYS.BOT]: false,
    },
    anyOtherSpecifics: "",
    activeProjectBased: null
}

export const sliceName = "taasTableSectionSlice"

export const taasTableSectionDataSlice = createSlice({
    name: sliceName,
    initialState,
    reducers: {
        setTaasBasedValues: (state, action) => {
            const { tableIdentifier, identifier, value, secondIdentifier = null } = action.payload
            if (tableIdentifier === TAAS_TABLE_SECTION_KEYS.TAAS_BASED) {
                state[tableIdentifier][identifier] = value
            }
            else {
                if (tableIdentifier === TAAS_TABLE_SECTION_KEYS.PROJECT_BASED) {
                    if (secondIdentifier === PROJECT_BASED_TABLE_KEYS.ESTIMATED_NUMBER_OF_HOURS_PER_MONTH) {
                        state.activeProjectBased = "hoursPerMonth"
                    }
                    else if (secondIdentifier === PROJECT_BASED_TABLE_KEYS.ESTIMATED_NUMBER_OF_PROJECTS_PER_MONTH) {
                        state.activeProjectBased = "projectsPerMonth"
                    }
                }
                state[tableIdentifier][secondIdentifier][identifier] = value
            }
        },
        setActiveCard: (state, action) => {
            const { identifier } = action.payload
            state.activeCards[identifier] = !state.activeCards[identifier]
        },
        setSpecificsText: (state, action) => {
            const { text } = action.payload
            state.anyOtherSpecifics = text
        },
        setCosts: (state, action) => {
            const { taasBasedCost, projectBasedCost, staffAugmentationBasedCost
                , botCost, projectBasedFromBackend = null } = action.payload
            state[TAAS_TABLE_SECTION_KEYS.TAAS_BASED].cost = taasBasedCost
            if (!projectBasedFromBackend) {
                if (state.activeProjectBased === "hoursPerMonth") state[TAAS_TABLE_SECTION_KEYS.PROJECT_BASED][PROJECT_BASED_TABLE_KEYS.ESTIMATED_NUMBER_OF_HOURS_PER_MONTH].cost = projectBasedCost
                else {
                    state[TAAS_TABLE_SECTION_KEYS.PROJECT_BASED][PROJECT_BASED_TABLE_KEYS.ESTIMATED_NUMBER_OF_PROJECTS_PER_MONTH].cost = projectBasedCost
                }
            }
            else {
                if (projectBasedFromBackend === "hoursPerMonth") state[TAAS_TABLE_SECTION_KEYS.PROJECT_BASED][PROJECT_BASED_TABLE_KEYS.ESTIMATED_NUMBER_OF_HOURS_PER_MONTH].cost = projectBasedCost
                else {
                    state[TAAS_TABLE_SECTION_KEYS.PROJECT_BASED][PROJECT_BASED_TABLE_KEYS.ESTIMATED_NUMBER_OF_PROJECTS_PER_MONTH].cost = projectBasedCost
                }
            }
            state[TAAS_TABLE_SECTION_KEYS.STAFF_AUGMENTATION][STAFF_AUGMENTATION_AND_BOT_TABLE_KEYS.ESTIMATED_NUMBER_OF_FTEs].cost = staffAugmentationBasedCost

            state[TAAS_TABLE_SECTION_KEYS.BOT][STAFF_AUGMENTATION_AND_BOT_TABLE_KEYS.ESTIMATED_NUMBER_OF_FTEs].cost = botCost
        },
        resetTaasTableDataSlice: (state, action) => {
            return initialState
        }
    }
})
export const { setTaasBasedValues, setActiveCard, setSpecificsText, setCosts, resetTaasTableDataSlice } = taasTableSectionDataSlice.actions

export const selectTaasBasedTableValuesFromSlice = state => state[sliceName]
export const selectActiveCards = state => state[sliceName].activeCards
export const selectAnyOtherSpecifics = state => state[sliceName].anyOtherSpecifics

export default taasTableSectionDataSlice.reducer